var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_vm._l((_vm.selectors),function(selector,index){return [_c('SelectorTypeShow',{key:index,attrs:{"selector":selector}})]}),_vm._v(" "),_c('SelectorAdd',{attrs:{"reference":_vm.reference}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }